import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";
import { Button, MenuItem } from "@material-ui/core";

import logo from "../../images/logo.svg";

const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  background-color: ${(props) => props.theme.palette.primary.main};
  box-shadow: ${(props) => props.theme.border.shadow + props.theme.palette.primary.main};

  color: ${(props) => props.theme.palette.secondary.light};
  font-weight: 600;
  font-size: 24px;

  margin: 0 0 0vh 0;
  padding: 2vh 2vw;

  height: 3vh;
  position: relative;
`;

const Logo = styled.img`
  width: 40px; //this is not responsive - Fix
`;
const Footer = () => {
  return (
    <StyledFooter>
      <div>
        <MenuItem component={Link} to="/">
          <Logo src={logo} />
        </MenuItem>
      </div>
      <div>
        <MenuItem component={Link} to="/about">
          About
        </MenuItem>
      </div>
      <div>
        <MenuItem component={Link} to="/contact">
          Contact
        </MenuItem>
      </div>
      <div>reForest</div>
    </StyledFooter>
  );
};

export default Footer;
